import CallEndIcon from '@mui/icons-material/CallEnd';
import { useMeetingManager } from 'amazon-chime-sdk-component-library-react';
import { useContext } from 'react';
import { RouteType } from '../../../../../router';
import ControlButton from "./control-button";
import { MeetingInfoContext } from '../../../../../context';

const LeaveCallButton: React.FC = () => {
    const meetingManager = useMeetingManager();
    const { isTraining } = useContext(MeetingInfoContext);

    const url = () => {
        const baseUrl = window.location.origin;
        const url = new URL(`${baseUrl}${RouteType.MeetingLeft}`);

        // Copy all optional params from current URL, except those already set
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.forEach((value, key) => {
            if (!url.searchParams.has(key)) {
                url.searchParams.append(key, value);
            }
        });

        if (isTraining) {
            url.searchParams.set("isTraining", "true");
        }

        return url.toString();
    };

    const leaveCall = () => {
        if (meetingManager) {
            meetingManager.leave();
        }

        window.location.href = url();
    }

    return (
        <ControlButton
            active={true}
            activeIcon={<CallEndIcon color="action" />}
            activeLabel={"Leave Call"}
            inactiveLabel={"Leave Call"}
            activeColor="#c62828"
            showText={false}
            onClick={leaveCall}
        />
    )
}

export default LeaveCallButton;